import React, { useState, useEffect, useRef, useCallback } from 'react';

const MediaSourceMenu = (props) => {
    const [optionsVisible, setOptionsVisible] = useState(false);

    const interactionCheck = useCallback((e) => {
        if (optionsVisible) {
            if (mediaSourceMenuRef.current && mediaSourceMenuRef.current.contains(e.target)) {
                return;
            }
            setOptionsVisible(false);
        }
    });

    useEffect((e) => {
        window.addEventListener('click', interactionCheck);

        return () => {
            window.removeEventListener('click', interactionCheck);
        }

    });

    const mediaSourceMenuRef = useRef();

    let mediaOptions = null,
        chevron = <i className="ion-arrow-down-b"/>;

    if (optionsVisible) {
        chevron = <i className="ion-arrow-up-b"/>;
        if (props.mediaSourceOptions !== undefined && props.mediaSourceOptions.length) {
            mediaOptions = (
                <div className="media-source-options">
                        <ul className="media-sources">
                            {props.mediaSourceOptions.map((option) => {
                                return (
                                    <li key={option.label} role="button" aria-label={option.label} onClick={(e) => {
                                        option.action();
                                        setOptionsVisible(false)
                                    }}>
                                        <i className={option.icon}/> {option.label}
                                    </li>
                                )
                            })}
                        </ul>
                </div>
            );
        }
    }

    return (
        <div className="media-source-menu-wrapper" ref={mediaSourceMenuRef}>
            <div className="media-source-combo" role="button" aria-label="Choose Media Source" onClick={(e) => {
                let nextOptionsVisible = optionsVisible ? false : true;
                setOptionsVisible(nextOptionsVisible);
            }}>
                <i className="ion-image"/> {chevron}
            </div>
            {mediaOptions}
        </div>
    );

};

export default MediaSourceMenu;
